import { Link } from "react-router-dom";

export function NotFoundPage() {
  return (
    <main className="simple-page not-found">
      <p className="page-kicker">OFF THE MAP</p>
      <h1>That path is not drawn yet.</h1>
      <Link className="btn btn-primary" to="/atlas">Return to the Atlas</Link>
    </main>
  );
}
